module.exports = __webpack_public_path__ + "static/media/twitters.576631ec.PNG";